<script setup>
import { BModal } from 'bootstrap-vue-next'
import DataTable from '@/components/DataTable.vue';
import { ref, defineProps } from 'vue'

defineProps({
  historyItem : Array,
  historyHeader : Array,
  togle : Boolean
})

const togle = ref(false)
</script>

<template>
     <BModal id="modal-tall" size="xl" :model-value="togle" centered no-footer @update:modelValue="updateModal" title="History">       
      <DataTable :data="historyItem" :header="historyHeader"></DataTable>
      <!-- <div v-if="historyitem.length == 0" class="p-4">
        <span class="text-secondary">No data</span>
      </div> -->
        
    </BModal>
</template>

